export default __webpack_public_path__ + "static/ProductGraphic2-06590174fb1b6c6f9e38d78fd692a8d3.png";